(function ($) {
  "use strict";

  $(document).ready(function () {
    // Optimalisation: Store the references outside the event handler:
    var $window = $(window);

    function checkWidth() {
      var windowsize = $window.width();
      if (windowsize < 978) {
        $('#wrapper').width(windowsize);
        $('.main-video-box-home').width(windowsize);
      }
    }

    // Execute on load
    checkWidth();
    // Bind event listener
    $(window).resize(checkWidth);
  });
})(jQuery);
